import {
  API_CUSTOS_PADRAO,
  API_CUSTOS_REAIS,
  API_VARIACOES_CUSTO,
} from '../api/apiConfig';
import { CustoPadraoProduto, CustoRealOP, VariacaoCusto } from '../types/custos';
import { createCrudService } from './crudFactory';

export const custosPadraoService =
  createCrudService<CustoPadraoProduto>(API_CUSTOS_PADRAO);
export const custosReaisService = createCrudService<CustoRealOP>(API_CUSTOS_REAIS);
export const variacoesCustoService =
  createCrudService<VariacaoCusto>(API_VARIACOES_CUSTO);
